module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.6090d256.ttf";